<template>
  <!-- <span
    v-if="selectedData.length > 2 && isMultipleFlag"
    class="align-self-center"
  >
    (+{{ selectedData.length - 2 }} others)
  </span> -->
  <!-- hint="You can select multiple options" -->
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    loader="dots"
    color="#007bff"
    :height="45"
    :width="75"
    :is-full-page="true"
  ></loading>
  <v-select
    class="font-weight-light"
    v-model="selectedData"
    :items="propsData"
    density="compact"
    variant="outlined"
    :item-title="finalTitle"
    :label="boxName"
    :item-value="finalColumn"
    persistent-hint
    :return-object="true ? returnType : false"
    :multiple="isMultipleFlag"
    @update:modelValue="clickHandler($event, e)"
  >
    <template v-slot:prepend-item>
      <div v-if="props.propsData !== undefined && props.propsData.length !== 0">
        <v-list-item title="Select All" @click="toggle">
          <template v-slot:prepend>
            <v-checkbox-btn
              :color="'indigo-darken-4'"
              :indeterminate="SomeItems && !AllItems"
              :model-value="selectAllFlag"
            ></v-checkbox-btn>
          </template>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </div>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index < 2">
        <span>{{ item.title }}</span>
      </v-chip>
      <span v-if="index === 2" class="text-grey text-caption align-self-center">
        (+{{ selectedData.length - 2 }} others)
      </span>
    </template>
    <!-- <template v-slot:append-item>
      <v-divider class="mb-2">sds</v-divider>
    </template> -->
    <!-- <template v-slot:item="prop">
  <div @click="changeEventHandler(prop.item.title)">
  {{prop.item.title }}</div>
  </template> -->
  </v-select>
</template>

<script setup>
import { ref, onBeforeMount, computed, watchEffect } from "vue";
import { defineProps } from "vue";
import { useStore } from "vuex";
import dropdownapis from "../../apis/dropdownapi.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
const props = defineProps({
  propsData: {
    type: Array,
  },
  boxName: {
    type: String,
  },

  isMultipleFlag: {
    type: Boolean,
    default: true,
  },
  returnType: {
    type: String,
    default: null,
  },
  clearFlag: {
    type: Boolean,
  },
});

// const emit = defineEmits({
//   setCategory: (data) => {
//     console.log("data", data);
//     return data;
//   },
// });
const store = useStore();
const isLoading = ref(false);

const { dropApiCall } = dropdownapis();
// const menuProps = {
//   // Set the font size here
//   style: {
//     "font-size": "4px", // Adjust the font size as needed
//   },
// };
const selectAllFlag = ref(false);
const selectedData = ref([]);
const view = ref([]);
const selectedID = ref();
const productName = ref(false);
const responseMFlagInsurance = ref(false);
const responseMFlagRest = ref(false);
const disResponseMFlagInsurance = ref(false);
const disResponseMFlagRest = ref(false);
const offerOrigin = ref(store.getters["Sector/getOfferOrigin"]);
// const apiExecutionerFlag = ref(false);
// const disableStatusExact = ref(true);
// const disableStatusOnly = ref(false);
// const OnlyCheckStatus = ref(true);
// const AnyCheckStatus = ref(true);
const finalTitle = ref("");
const finalId = ref();
// const datagot = ref([]);
// let dropdownData = ref([]);
const emitFlag = ref(false);
const previousSelectedStructures = ref([]);
const disSelect = ref();
const finalColumn = ref("");
const selectAllDisable = ref(false);
const sectorIdsSelected = ref([]);
// const enableCreditCard = ref(false);
const enableAudienceAll = ref(false);
const checkCommType = ref(0);
// const filtOr = ref([]);
onBeforeMount(() => {
  // console.log("Delivery.", props.propsData);
  // console.log("Delivery.", props.boxName);
  // console.log("boxName", props.isMultipleFlag);
  if (props.boxName === "Media Channel") {
    finalTitle.value = "mChannelName";
    finalId.value = "mChannelID";
    finalColumn.value = "mChannelID";
  } else if (props.boxName === "Sectors") {
    finalTitle.value = "sectorName";
    finalId.value = "sectorID";
    finalColumn.value = "sectorID";
  } else if (props.boxName === "Audience") {
    finalTitle.value = "mPanelName";
    finalId.value = "mPanelID";
    finalColumn.value = "mPanelID";
  } else if (props.boxName === "Ancillary Products") {
    finalTitle.value = "ancillary_name";
    finalColumn.value = "ancillary_id";
  } else if (props.boxName === "State/Province") {
    finalTitle.value = "stateName";
    finalColumn.value = "stateID";
  } else if (props.boxName === "Group Size") {
    finalTitle.value = "name";
    finalColumn.value = "id";
  } else if (props.boxName === "FicoScore") {
    finalTitle.value = "score_range";
    finalColumn.value = "id";
  } else if (props.boxName === "CreditVision") {
    finalTitle.value = "score_range";
    finalColumn.value = "id";
  } else if (props.boxName === "VantageScore") {
    finalTitle.value = "score_range";
    finalColumn.value = "id";
  } else if (props.boxName === "Delivery Method") {
    finalTitle.value = "delmethname";
    finalId.value = "delmethid";
    finalColumn.value = "delmethid";
  } else if (props.boxName === "Electronic Type") {
    finalTitle.value = "electronic_name";
    finalColumn.value = "electronic_id";
  } else if (props.boxName === "Publication Type") {
    finalTitle.value = "print_typeName";
    finalColumn.value = "print_typeID";
  } else if (props.boxName === "Network Name") {
    finalTitle.value = "value";
  } else if (props.boxName === "Card Network") {
    finalTitle.value = "CardTypeName";
    finalColumn.value = "CardTypeID";
  } else if (props.boxName === "Application Type") {
    finalTitle.value = "ApplicationTypeName";
    finalColumn.value = "ApplicationTypeID";
  } else if (props.boxName === "Social Media Ad Type") {
    finalTitle.value = "value";
  } else if (props.boxName === "Package Type") {
    finalTitle.value = "packageName";
    finalColumn.value = "packageTypeId";
  } else if (props.boxName === "Postage") {
    finalTitle.value = "postageName";
    finalColumn.value = "postageId";
  } else if (props.boxName === "Delivery Type") {
    finalTitle.value = "deliveryTypeName";
    finalColumn.value = "deliveryTypeId";
  } else if (props.boxName === "Pre-Sorted") {
    finalTitle.value = "presortedName";
    finalColumn.value = "presortedId";
  } else if (props.boxName === "Response Mechanism") {
    finalTitle.value = "responseMechName";
    finalId.value = "responseMechID";
    finalColumn.value = "responseMechID";
  } else if (props.boxName === "Introductory Pricing") {
    finalTitle.value = "value";
    finalColumn.value = "id";
  } else if (props.boxName === "EDC / LDC / TDSP") {
    finalTitle.value = "edc_name";
    finalColumn.value = "edc_id";
  } else if (props.boxName === "Energy - Rate Type") {
    finalTitle.value = "name";
    finalColumn.value = "id";
  } else if (props.boxName === "Offer Price (¢ per kWh)") {
    finalTitle.value = "OfferPriceName";
  } else if (props.boxName === "Energy - Term Length") {
    finalTitle.value = "TermLengthName";
    finalColumn.value = "TermLengthID";
  } else if (props.boxName === "Communication Type") {
    finalTitle.value = "type";
    finalColumn.value = "ID";
  } else if (props.boxName === "Mailing Type") {
    finalTitle.value = "mTypeName";
    finalId.value = "mTypeID";
    finalColumn.value = "mTypeID";
  } else if (props.boxName === "Business Content") {
    finalTitle.value = "text_value";
    finalId.value = "key_id";
    finalColumn.value = "key_id";
  } else if (props.boxName === "Income") {
    finalTitle.value = "incomeName";
    finalId.value = "incomeID";
    finalColumn.value = "incomeID";
  } else if (props.boxName === "Age") {
    finalTitle.value = "age_pname";
    finalId.value = "age_pID";
    finalColumn.value = "age_pID";
  } else if (props.boxName === "DMA®") {
    finalTitle.value = "description";
    finalId.value = "code";
    finalColumn.value = "code";
  } else if (props.boxName === "Income Producing Assets Segment Code *R*") {
    finalTitle.value = "description";
    finalId.value = "code";
    finalColumn.value = "code";
  } else if (props.boxName === "Value Score") {
    finalTitle.value = "description";
    finalId.value = "code";
    finalColumn.value = "code";
  } else if (props.boxName === "Face Amount") {
    selectAllDisable.value = true;
    finalTitle.value = "fa_name";
    finalId.value = "fa_id";
    finalColumn.value = "fa_id";
  } else if (props.boxName === "Term Length") {
    // console.log("Term length", props.propsData);
    finalTitle.value = "name";
    finalColumn.value = "id";
  } else if (props.boxName === "Riders") {
    finalTitle.value = "ridersName";
    finalId.value = "ridersID";
    finalColumn.value = "ridersID";
  } else if (props.boxName === "Issue Type") {
    finalTitle.value = "IssueTypeName";
    finalId.value = "IssueTypeID";
    finalColumn.value = "IssueTypeID";
  } else if (props.boxName === "Target Markets") {
    finalTitle.value = "value";
    finalId.value = "id";
    finalColumn.value = "id";
  }
  // responseMechanismData.value =
  // store.getters["Sector/getresponseMechanismAPIGett"];
  // console.log("final", finalTitle);
});

watchEffect(() => {
  // console.log("Delivery.", store.getters["Sector/getAllSectorsGetters"]);

  let dropdown = store.getters["Media/getselectedDataGetters"];
  let additionalDropdown =
    store.getters["Media/getAdditionalSelectedDataGetters"];
  if (store.getters["Media/getlastSearchTriggerredGetters"]) {
    // let key = Object.keys(dropdown);
    // let value = Object.values(dropdown);
    // console.log(dropdown, "key");
    // if (key === "media") {
    //console.log(dropdown, "val");
    if (props.boxName === "Media Channel") {
      selectedData.value = dropdown["mChannelID"];
      viewValueGetter(selectedData.value, "mChannelID");

      // for (let o in selectedData.value) {
      //   view.value.push(selectedData.value[o].mChannelID);
      // }
      // dropdown["mChannelID"]?.forEach((t) => {
      //   store.dispatch("Rawdata/setmediaAPIPayloadAction", t.mChannelID);
      // });
      // console.log(dropdown["media"], "me");
    }
    if (props.boxName === "Sectors") {
      selectedData.value = dropdown["sectorID"];
      // dropdown["sectorID"]?.forEach((t) => {
      //   store.dispatch("Rawdata/setsectorAPIPayloadAction", t.sectorID);
      // });
      viewValueGetter(selectedData.value, "sectorID");

      // for (let o in selectedData.value) {
      //   view.value.push(selectedData.value[o].sectorID);
      // }
    }
    if (props.boxName === "Audience") {
      selectedData.value = dropdown["mPanelID"];
      dropdown["mPanelID"]?.forEach((t) => {
        store.dispatch("Rawdata/setaudienceAPIPayloadAction", t.mPanelID);
      });
      viewValueGetter(selectedData.value, "mPanelID");

      // for (let o in selectedData.value) {
      //   view.value.push(selectedData.value[o].sectorID);
      // }
    }
  }
  if (store.getters["Media/getlastSearchTriggerredGetters"]) {
    // console.log(additionalDropdown, "additiondropdown");
    if (props.boxName === "Electronic Type") {
      selectedData.value = additionalDropdown["electronicID_mult"];
      viewValueGetter(selectedData.value, "electronic_id");
      // additionalDropdown["electronicID_mult"]?.forEach((t) => {
      //   store.dispatch(
      //     "Rawdata/setelectronicTypePayloadAction",
      //     t.electronic_id
      //   );
      // });
    }

    if (props.boxName === "Card Network") {
      selectedData.value = additionalDropdown["CardNetwork_mult"];
      viewValueGetter(selectedData.value, "CardTypeID");
    }
    if (props.boxName === "Response Mechanism") {
      selectedData.value = additionalDropdown["responseMechID_mult"];
      viewValueGetter(selectedData.value, "responseMechID");
    }
    if (props.boxName === "Ancillary Products") {
      selectedData.value = additionalDropdown["FeeProductType"];
      viewValueGetter(selectedData.value, "ancillary_id");
    }
    if (props.boxName === "State/Province") {
      selectedData.value = additionalDropdown["state"];
      viewValueGetter(selectedData.value, "stateID");
    }
    if (props.boxName === "Age") {
      selectedData.value = additionalDropdown["age"];
      viewValueGetter(selectedData.value, "age_pID");
    }
    if (props.boxName === "Income") {
      selectedData.value = additionalDropdown["income_mult"];
      viewValueGetter(selectedData.value, "incomeID");
    }
    if (props.boxName === "CreditVision") {
      selectedData.value = additionalDropdown["credit_vision_score"];
      viewValueGetter(selectedData.value, "id");
    }
    if (props.boxName === "VantageScore") {
      selectedData.value = additionalDropdown["vantage_score"];
      viewValueGetter(selectedData.value, "id");
    }
    if (props.boxName === "FicoScore") {
      selectedData.value = additionalDropdown["fico_score"];
      viewValueGetter(selectedData.value, "id");
    }
    if (props.boxName === "Application Type") {
      selectedData.value = additionalDropdown["ApplicationType_mult"];
      viewValueGetter(selectedData.value, "ApplicationTypeID");
    }
    if (props.boxName === "Introductory Pricing") {
      selectedData.value = additionalDropdown["IntroPricing_mult"];
      viewValueGetter(selectedData.value, "id");
    }
    if (props.boxName === "Postage") {
      selectedData.value = additionalDropdown["postageId"];
      viewValueGetter(selectedData.value, "postageId");
    }
    if (props.boxName === "Business Content") {
      selectedData.value = additionalDropdown["businessContent_mult"];
      viewValueGetter(selectedData.value, "key_id");
    }
    if (props.boxName === "Communication Type") {
      selectedData.value = additionalDropdown["agentCommunicationID"];
      viewValueGetter(selectedData.value, "ID");
    }
    if (props.boxName === "Delivery Method") {
      selectedData.value = additionalDropdown["delmethid_mult"];
      viewValueGetter(selectedData.value, "delmethid");
    }
    if (props.boxName === "Delivery Type") {
      selectedData.value = additionalDropdown["deliveryTypeId"];
      viewValueGetter(selectedData.value, "deliveryTypeId");
    }
    if (props.boxName === "Mailing Type") {
      selectedData.value = additionalDropdown["mTypeID"];
      viewValueGetter(selectedData.value, "mTypeID");
    }
    if (props.boxName === "Pre-Sorted") {
      selectedData.value = additionalDropdown["presortedId"];
      viewValueGetter(selectedData.value, "presortedId");
    }
    if (props.boxName === "Group Size") {
      selectedData.value = additionalDropdown["groupSize"];
      viewValueGetter(selectedData.value, "id");
    }
    if (props.boxName === "Energy - Rate Type") {
      selectedData.value = additionalDropdown["ERateType_mult"];
      viewValueGetter(selectedData.value, "mPanelID");
    }
    if (props.boxName === "Offer Price (¢ per kWh)") {
      selectedData.value = additionalDropdown["EOfferPrice_mult"];
      viewValueGetter(selectedData.value, "mPanelID");
    }
    if (props.boxName === "Energy - Term Length") {
      selectedData.value = additionalDropdown["ETermLength_mult"];
      viewValueGetter(selectedData.value, "id");
    }
    if (props.boxName === "Value Score") {
      selectedData.value = additionalDropdown["value_score"];
      viewValueGetter(selectedData.value, "code");
    }
    if (props.boxName === "Riders") {
      selectedData.value = additionalDropdown["riders_mult"];
      viewValueGetter(selectedData.value, "ridersID");
    }
    if (props.boxName === "Issue Type") {
      selectedData.value = additionalDropdown["IssueTypeID_mult"];
      viewValueGetter(selectedData.value, "IssueTypeID");
    }
    if (props.boxName === "DMA®") {
      selectedData.value = additionalDropdown["DMA_ID_mult"];
      viewValueGetter(selectedData.value, "code");
    }
    if (props.boxName === "Publication Type") {
      selectedData.value = additionalDropdown["pubTypeID_mult"];
      viewValueGetter(selectedData.value, "print_typeID");
    }
    // }
  }
  // console.log(selectedData.value, "sel");
  if (props.clearFlag) selectedData.value = [];
  // console.log(selectedData.value, "aa");
  // console.log(Object.keys(selectedData.value).length, "aa");
  // console.log(props.propsData, "bbb");
  if (
    props.propsData !== undefined &&
    props.propsData !== null &&
    selectedData.value !== undefined &&
    selectedData.value !== null
  ) {
    if (
      Object.keys(props.propsData).length !==
      Object.keys(selectedData.value).length
    ) {
      selectAllFlag.value = false;
      // selectedData.value.forEach((t) => {
      //   view.value.push(t.sectorID);
      //   console.log(t.sectorID, "secid");
      // });
    } else {
      selectAllFlag.value = true;
      // selectedData.value.forEach((t) => {
      //   view.value.push(t.sectorID);
      // });
    }
  }
  if (props.boxName === "Communication Type") {
    // console.log(
    //   "finalCommData.....",
    //   props.propsData.length,
    //   checkCommType.value,
    //   props.boxName
    // );
    if (
      props.propsData.length !== 0 &&
      props.propsData.length < checkCommType.value
    ) {
      // console.log("finalCommData...props.propsData", props.propsData.length);
      selectedData.value = props.propsData;
      selectAllFlag.value = true;
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.ID !== undefined) {
          selData.push(i.ID);
        }
      });
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    }
    if (props.propsData.length === 0) {
      selectedData.value = props.propsData;
      store.dispatch("Sector/setSiDropDownPayload", []);
    }
  }
});
function mediaHandler() {
  const len = selectedData.value.length;
  // console.log("mediaHandler", selectedData.value[len - 1]);
  switchMediaFunctionCases(selectedData.value[len - 1]);
}

function mediaDisSelectionHandler(element) {
  // switchMediaFunctionCases(element);
  // console.log("dis media", element);
  let directMail = store.getters["Media/getDeliveryDirectMailFlagGetters"];
  // let dashboardExist = selectedData.value.includes(13);
  // let dashboardFlag = store.getters["Media/getDeliveryDirectMailFlagGetters"];
  // let socialFlag = store.getters["Media/getsocialNetworkNameBoxFlagGetters"];
  // let emailFlag = store.getters["Media/getEmailElectronicTypeBoxFlagGetters"];
  // let printFlag = store.getters["Media/getprintPublicationTypeBoxFlagGetters"];
  let dashbBoardFlag = store.getters["Media/getDashboardBoxFlagGetters"];
  // let dashboardDirectMailFlag =
  //   store.getters["Media/getDashboardDirectMailOptionBoxFlagGetters"];

  // console.log(isdashboardExist.value);
  switch (element) {
    case 2:
      store.dispatch("Media/setPrintPublicationTypeBoxFlag", false);
      // console.log("print", emitFlag.value);
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      break;
    case 1:
      // emitFlag.value = store.getters["Media/getDeliveryDirectMailFlagGetters"];
      // emitFlag.value = !emitFlag.value;
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      // console.log("emit", emitFlag.value);
      store.dispatch("Media/setDeliveryDirectMailFlag", false);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      // console.log("stat", selectedData.value.includes(13));
      if (dashbBoardFlag) {
        store.dispatch("Media/setDashboardDirectMailBoxFlagAction", false);
      }
      break;
    case 3:
      // emitFlag.value =
      //   store.getters["Media/getEmailElectronicTypeBoxFlagGetters"];
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      // store.dispatch("Rawdata/setWrenchIconAction", element);
      // emitFlag.value = !emitFlag.value;
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setEmailElectronicTypeBoxFlag", false);
      break;
    case 6:
      // emitFlag.value = !emitFlag.value;
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setSocialNetworkNameBoxFlag", false);
      break;
    case 13:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setDashboardBoxFlagAction", false);
      if (directMail) {
        store.dispatch("Media/setDashboardDirectMailBoxFlagAction", false);
      }
      break;
    case 5:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setDashboardBoxFlagAction", false);
      break;
    case 10:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setDashboardBoxFlagAction", false);
      break;
    case 9:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setDashboardBoxFlagAction", false);
      break;
    case 14:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setDashboardBoxFlagAction", false);
      break;
  }
}

const AllItems = computed(() => {
  return selectedData.value.length === props.propsData.length;
});

const SomeItems = computed(() => {
  return selectedData.value?.length;
});

function toggle() {
  // console.log(selectedData.value, "box");
  // console.log(props.boxName, "box");
  selectedData.value = [];
  // enableCreditCard.value = false;
  disSelect.value = null;
  enableAudienceAll.value = false;
  selectAllFlag.value = !selectAllFlag.value;
  store.dispatch("Sector/setSelectAllFlagAction", selectAllFlag.value);
  store.dispatch("Rawdata/setsearchBtnDisabledFlagAction", false);

  // let bankCardBox = store.getters["Sector/getBankingCardGetters"];
  // let bankCombo = store.getters["Sector/getCreditComboBoxesGetters"];
  // let travelCombo = store.getters["Sector/getTravelRetailBoxFlagGetters"];
  // let retailCombo = store.getters["Sector/getCreditComboBoxesGetters"];
  if (selectAllFlag.value) {
    selectedData.value = props.propsData;
    // console.log(selectedData.value, "selectedData.value");
    if (props.boxName === "Media Channel") {
      // let dropdown = store.getters["Media/getselectedDataGetters"];
      // dropdown["mChannelID"] = [];
      selectedData.value.forEach((i) => {
        view.value.push(i.mChannelID);
        // console.log(i.mChannelID, "media");
        // store.dispatch("Rawdata/setmediaAPIPayloadAction", i.mChannelID);
        // setTimeout(() => {
        switchMediaFunctionCases(i.mChannelID);
        // }, 1000 * index);
      });
      const searchCry = {
        val: view.value,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
    } else if (props.boxName === "Sectors") {
      // let creditBankFlag = false;
      // let travelFlag = false;
      // let retailFlag = false;
      let allsectorIds = [];
      // const offerOriData = [];
      let travelRetailCombo = [266, 219, 559, 560];
      let autoBankCredit = [87, 90];
      // Check if any sectorID value exists in travelRetailCombo
      let isTravelRetailCombo = selectedData.value.some((data) =>
        travelRetailCombo.includes(data.sectorID)
      );
      // console.log(isTravelRetailCombo, "isTravelRetailCombo");
      // console.log(selectedData.value, "selectedData.value");

      let isBankCreditCombo = selectedData.value.some((data) =>
        autoBankCredit.includes(data.sectorID)
      );
      let ismortageLoan = selectedData.value.some((data) =>
        [6].includes(data.sectorID)
      );
      if (ismortageLoan) {
        store.dispatch("Sector/setMortageSelectedAction", true);
      }
      // console.log(isBankCreditCombo, "isBankCreditCombo");
      if (isBankCreditCombo) {
        store.dispatch("Sector/setBankingCardAction", true);
        store.dispatch("Sector/setCreditComboBoxesAction", true);
      } else if (!isBankCreditCombo) {
        store.dispatch("Sector/setCreditComboBoxesAction", false);
        store.dispatch("Sector/setBankingCardAction", false);
      }
      if (isTravelRetailCombo) {
        store.dispatch("Sector/setTravelRetailBoxFlagAction", true);
      } else {
        store.dispatch("Sector/setTravelRetailBoxFlagAction", false);
      }
      selectedData.value.forEach((i) => {
        view.value.push(i.sectorID);
        allsectorIds.push(i.sectorID);
        offerOriginFn(i.sectorID, "add");
        //offerOriData.push(i.sectorID);
        view.value.push(i.sectorID);

        switchSectorFunctionCases(i.sectorID);
      });
      const searchCry = {
        val: allsectorIds,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      // store.dispatch("Rawdata/setsectorAPIPayloadAction", i.sectorID);
      // console.log(i.sectorID, 9);

      // fetch("https://api5.competiscan.com/vat-backend/v1/data/sectors", {
      //   method: "POST",
      //   headers: {
      //     Authorization:
      //       "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({
      //     sectors: allsectorIds,
      //   }),
      // }).then((response) => {
      //   response.json().then(async (data) => {
      //     console.log("newapidata", data);
      //   });
      // });
      //offerOrigin(offerOriData);
    } else if (props.boxName === "Audience") {
      selectedData.value.forEach((i) => {
        // console.log(i.mPanelID, "aud11");
        view.value.push(i.mPanelID);
        // store.dispatch("Rawdata/setaudienceAPIPayloadAction", i.mPanelID);
        // setTimeout(() => {
        switchAudienceFunctionCases(i.mPanelID);
        // }, 1000 * index);
      });
      const searchCry = {
        val: view.value,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
    } else if (props.boxName === "EDC / LDC / TDSP") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.edc_id !== undefined) {
          selData.push(i.edc_id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Energy - Rate Type") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Offer Price (¢ per kWh)") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.OfferPriceID !== undefined) {
          selData.push(i.OfferPriceName);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Energy - Term Length") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.TermLengthID !== undefined) {
          selData.push(i.TermLengthID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Term Length") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Mailing Type") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.mTypeID !== undefined) {
          selData.push(i.mTypeID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "DMA®") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.code !== undefined) {
          selData.push(i.code);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Age") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.age_pID !== undefined) {
          selData.push(i.age_pID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Business Content") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.key_id !== undefined) {
          selData.push(i.key_id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "VantageScore") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Riders") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.ridersID !== undefined) {
          selData.push(i.ridersID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Face Amount") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.fa_id !== undefined) {
          selData.push(i.fa_id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Income") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.incomeID !== undefined) {
          selData.push(i.incomeID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Income Producing Assets Segment Code *R*") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.code !== undefined) {
          selData.push(i.code);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Value Score") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.code !== undefined) {
          selData.push(i.code);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Application Type") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.ApplicationTypeID !== undefined) {
          selData.push(i.ApplicationTypeID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "FicoScore") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "CreditVision") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "State/Province") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.stateID !== undefined) {
          selData.push(i.stateID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Communication Type") {
      const selData = [];
      checkCommType.value = selectedData.value.length;
      selectedData.value.forEach((i) => {
        if (i.ID !== undefined) {
          selData.push(i.ID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Ancillary Products") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.ancillary_id !== undefined) {
          selData.push(i.ancillary_id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setDefaultDropdown", pay);
    } else if (props.boxName === "Response Mechanism") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.responseMechID !== undefined) {
          selData.push(i.responseMechID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setDefaultDropdown", pay);
    } else if (props.boxName === "Card Network") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.CardTypeID !== undefined) {
          selData.push(i.CardTypeID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      const pay = {
        values: selData,
        boxname: props.boxName,
      };
      store.dispatch("Sector/setDefaultDropdown", pay);
    } else if (props.boxName === "Delivery Method") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.delmethid !== undefined) {
          selData.push(i.delmethid);
        }
      });
      if (selData.includes(1) || selData.includes(3) || selData.includes(7)) {
        store.dispatch("Media/setDashboardDirectMailBoxFlagAction", true);
      } else {
        store.dispatch("Sector/setPostageId", []);
        store.dispatch("Sector/setDeliveryTypeId", []);
        store.dispatch("Sector/setPresortedId", []);
        store.dispatch("Sector/setPackageTypeId", []);
        store.dispatch("Media/setDashboardDirectMailBoxFlagAction", false);
      }
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setDeliveryMethodId", selData);
    } else if (props.boxName === "Delivery Type") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.deliveryTypeId !== undefined) {
          selData.push(i.deliveryTypeId);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setDeliveryTypeId", selData);
    } else if (props.boxName === "Postage") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.postageId !== undefined) {
          selData.push(i.postageId);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setPostageId", selData);
    } else if (props.boxName === "Pre-Sorted") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.presortedId !== undefined) {
          selData.push(i.presortedId);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setPresortedId", selData);
    } else if (props.boxName === "Package Type") {
      const selData = [];
      // console.log("WS", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.packageTypeId !== undefined) {
          selData.push(i.packageTypeId);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setPackageTypeId", selData);
    } else if (props.boxName === "Target Markets") {
      const selData = [];
      // console.log("WS.", selectedData.value);
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setTargetIDs", selData);
    } else if (props.boxName === "Electronic Type") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.electronic_id !== undefined) {
          selData.push(i.electronic_id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Rawdata/setelectronicTypePayloadAction", selData);
    } else if (props.boxName === "Publication Type") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.print_typeID !== undefined) {
          selData.push(i.print_typeID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Rawdata/setPublicationTypePayloadAction", selData);
    } else if (props.boxName === "Group Size") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Rawdata/setgroupSizePayloadPayloadAction", selData);
    } else if (props.boxName === "Issue Type") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.IssueTypeID !== undefined) {
          selData.push(i.IssueTypeID);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Rawdata/setissueTypePayloadAction", selData);
    } else if (props.boxName === "Introductory Pricing") {
      const selData = [];
      selectedData.value.forEach((i) => {
        if (i.id !== undefined) {
          selData.push(i.id);
        }
      });
      const searchCry = {
        val: selData,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Rawdata/setintroductoryPricingPayloadAction", selData);
    }
  } else {
    view.value = [];
    const searchCry = {
      val: view.value,
      column: props.boxName,
      entirs: props.propsData,
    };
    store.dispatch("Rawdata/setSearchCritertia", searchCry);
    if (props.boxName === "Media Channel") {
      selectedData.value = [];
      store.dispatch("Media/setPrintPublicationTypeBoxFlag", false);

      store.dispatch("Media/setDeliveryDirectMailFlag", false);

      store.dispatch("Media/setDashboardDirectMailBoxFlagAction", false);
      //   store.dispatch("Media/getEmailElectronicTypeBoxFlagGetters", false)
      let dropdown = store.getters["Media/getselectedDataGetters"];
      dropdown["mChannelID"] = [];
      store.dispatch("Media/setEmailElectronicTypeBoxFlag", false);

      store.dispatch("Media/setSocialNetworkNameBoxFlag", false);

      store.dispatch("Media/setDashboardBoxFlagAction", false);
      isLoading.value = true;
      store.dispatch("Rawdata/setmediaAPIPayloadAction", "e");
      isLoading.value = false;
    } else if (props.boxName === "Sectors") {
      // console.log("Sector All uncheck");
      // console.log(selectedData.value);
      offerOriginFn(0, "all");
      selectedData.value = [];
      store.dispatch("Sector/setTravelRetailBoxFlagAction", false);
      store.dispatch("Sector/setEnergyBoxesFlag", false);

      store.dispatch("Sector/setInsuranceBoxFlagAction", false);
      let dropdown = store.getters["Media/getselectedDataGetters"];
      dropdown["sectorID"] = [];
      store.dispatch("Sector/setInvestmentBoxFlagAction", false);
      let catPayload = store.getters["Sector/getcategoryPayload"];

      Object.keys(catPayload).find((key) => {
        if (key === "cat_") {
          // console.log(state.categoryPayload[key], "key");
          // console.log(typeof state.categoryPayload[key], "key");
          catPayload[key] = [];
        } else if (key === "cat_sub") {
          catPayload[key] = [];
        } else if (key === "cat_ssub") {
          catPayload[key] = [];
        }
      });
      let commPay = {
        id: -1,
        sleBox: "sector",
        status: "dis",
      };
      store.dispatch("Sector/setCommunicationTypeData", commPay);
      store.dispatch("Sector/setMortageSelectedAction", false);
      store.dispatch("Sector/setSelectAllFlagAction", false);
      store.dispatch("Sector/setsubcategorySelectedAct", []);
      store.dispatch("Sector/setcategorySelectedAct", []);
      store.dispatch("Sector/setsubsubcategorySelectedAct", []);
      store.dispatch("Sector/setresponseMechanismAction", false);
      store.dispatch("Sector/setProductNameAction", false);
      store.dispatch("Sector/setBankingCardAction", false);

      store.dispatch("Sector/setCreditComboBoxesAction", false);
      // store.dispatch("Sector/setSectorIdsComm", 0);
      // store.dispatch("Sector/setSectorCommData", []);
      store.dispatch("Sector/setCategoryAction", []);
      store.dispatch("Sector/setProductNameAction", []);
      store.dispatch("Sector/setSubCategoryAction", []);
      store.dispatch("Sector/setSubSubCategoryAction", []);
      store.dispatch("Sector/setCategoryFieldsCleaningAction", true);
      isLoading.value = true;

      store.dispatch("Rawdata/setsectorAPIPayloadAction", "e");
      isLoading.value = false;
    } else if (props.boxName === "Audience") {
      store.dispatch("Audience/setpersonalizedFlagAction", false);
      store.dispatch("Audience/setConsumerEmpBoxesFlagAction", false);
      store.dispatch("Audience/setInsuranceBoxFlagAction", false);
      // store.dispatch("Sector/setSectorIdsComm", 0);
      let dropdown = store.getters["Media/getselectedDataGetters"];
      dropdown["mPanelID"] = [];
      isLoading.value = true;
      store.dispatch("Rawdata/setaudienceAPIPayloadAction", "e");
      let commPay = {
        id: -1,
        sleBox: "audience",
        status: "dis",
      };
      store.dispatch("Sector/setCommunicationTypeData", commPay);
      isLoading.value = false;
    } else if (props.boxName === "EDC / LDC / TDSP") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Energy - Rate Type") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Offer Price (¢ per kWh)") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Energy - Term Length") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setEnergySetPayload", pay);
    } else if (props.boxName === "Mailing Type") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "DMA®") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Age") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Business Content") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "VantageScore") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Riders") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Face Amount") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Income") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Income Producing Assets Segment Code *R*") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Value Score") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Application Type") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "FicoScore") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "CreditVision") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "State/Province") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Ancillary Products") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setDefaultDropdown", pay);
    } else if (props.boxName === "Communication Type") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    } else if (props.boxName === "Response Mechanism") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setDefaultDropdown", pay);
    } else if (props.boxName === "Card Network") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setDefaultDropdown", pay);
    } else if (props.boxName === "Delivery Method") {
      const pay = [];
      store.dispatch("Media/setDashboardDirectMailBoxFlagAction", false);
      store.dispatch("Sector/setDeliveryMethodId", pay);
    } else if (props.boxName === "Delivery Type") {
      const selData = [];
      store.dispatch("Sector/setDeliveryTypeId", selData);
    } else if (props.boxName === "Postage") {
      const selData = [];
      store.dispatch("Sector/setPostageId", selData);
    } else if (props.boxName === "Pre-Sorted") {
      const selData = [];
      store.dispatch("Sector/setPresortedId", selData);
    } else if (props.boxName === "Package Type") {
      const selData = [];
      store.dispatch("Sector/setPackageTypeId", selData);
    } else if (props.boxName === "Target Markets") {
      const selData = [];
      store.dispatch("Sector/setTargetIDs", selData);
    } else if (props.boxName === "Electronic Type") {
      const selData = [];
      store.dispatch("Rawdata/setelectronicTypePayloadAction", selData);
    } else if (props.boxName === "Publication Type") {
      const selData = [];
      store.dispatch("Rawdata/setPublicationTypePayloadAction", selData);
    } else if (props.boxName === "Group Size") {
      const selData = [];
      store.dispatch("Rawdata/setgroupSizePayloadPayloadAction", selData);
    } else if (props.boxName === "Issue Type") {
      store.dispatch("Rawdata/setissueTypePayloadAction", null);
    } else if (props.boxName === "Introductory Pricing") {
      // console.log("WS.", selectedData.value);
      store.dispatch("Rawdata/setintroductoryPricingPayloadAction", []);
    } else if (props.boxName === "Term Length") {
      const pay = {
        values: [],
        boxname: props.boxName,
      };
      store.dispatch("Sector/setSiDropDownPayload", pay);
    }
  }
}

function sectorsDisSelectionHandler(element) {
  console.log("secdis", element);
  // console.log(typeof element);
  let categoryData = store.getters["Sector/getcategorySector"];
  let subcategoryData = store.getters["Sector/getSubCategoryGetters"];
  let subsubcategoryData = store.getters["Sector/getSubSubCategoryGetters"];
  let CatSelectedData = store.getters["Sector/getCategorySelectedGetters"];
  let subCatSelectedData =
    store.getters["Sector/getSubCategorySelectedGetters"];
  let subCatData = store.getters["Sector/getSubCategoryGetters"];
  let subsubCatData = store.getters["Sector/getSubSubCategoryGetters"];
  let subsubCatSelectedData =
    store.getters["Sector/getsubSubCategorySelectedGetters"];
  // console.log(categoryData, "cat");
  // enableCreditCard.value = true;
  const allSectorIds = store.getters["Sector/getsectorIdComm"];
  // const allcommData = store.getters["Sector/getSectorCommData"];
  // console.log(allSectorIds, "allSectorIds");
  // const originalCommunication =
  //   store.getters["Rawdata/getDropdownDataAPI"].communication_type;
  let insurance = !selectedData.value.includes(4);
  if (!insurance) {
    store.dispatch("Sector/setInsuranceBoxFlagAction", true);
  } else {
    store.dispatch("Sector/setInsuranceBoxFlagAction", false);
  }
  let travelRetailCombo = [266, 219, 559, 560].some((i) =>
    selectedData.value.includes(i)
  );
  if (travelRetailCombo) {
    store.dispatch("Sector/setTravelRetailBoxFlagAction", travelRetailCombo);
  } else {
    store.dispatch("Sector/setTravelRetailBoxFlagAction", travelRetailCombo);
  }
  // console.log(categoryData, "categoryData");
  switchSectorFunctionCases(element);
  for (const i in categoryData) {
    //problem here
    // console.log(categoryData[i].id, "i");
    if (categoryData[i].pid == element) {
      // console.log(element, "ele inside");
      // switchSectorFunctionCases(element);
      break;
      // categoryData.splice(i, count);
      // store.dispatch("Sector/setCategoryAction", categoryData);
    }

    const findID = (e) => e === element;
    let indValue = sectorIdsSelected.value.findIndex(findID);
    if (indValue !== -1) {
      sectorIdsSelected.value.slice(indValue, 1);
    }
  }

  if (element == 87 || element === 90) {
    store.dispatch("Sector/setBankingCardAction", false);
  }

  if (element == 90) {
    store.dispatch("Sector/setCreditComboBoxesAction", false);
  }
  // console.log(allSectorIds);
  // console.log(storeData);
  let deletingids = [];

  for (const cat in categoryData) {
    if (categoryData[cat].pid === element) {
      deletingids.push(categoryData[cat].id);
    }
  }
  for (const i in categoryData) {
    for (const j in deletingids) {
      if (deletingids[j] == categoryData[i].id) {
        categoryData.splice(i, 1);
      }
    }
    store.dispatch("Sector/setCategoryFieldsCleaningAction", true);
  }
  // console.log(categoryData, "categoryData");
  // store.dispatch("Sector/setCategoryAction", categoryData);
  // subcat

  for (const subcat in subcategoryData) {
    let status = deletingids.includes(subcategoryData[subcat].id);
    if (status) {
      deletingids.push(subcategoryData[subcat].id);
    }
  }
  // console.log(subcount, "subcount");

  for (const i in subcategoryData) {
    for (const j in deletingids) {
      if (deletingids[j] == subcategoryData[i].id) {
        subcategoryData.splice(i, 1);
      }
    }
  }
  // console.log(subcategoryData, "subcategoryData");

  // subsubcat

  for (const subcat in subsubcategoryData) {
    let status = deletingids.includes(subsubcategoryData[subcat].id);
    if (status) {
      deletingids.push(subsubcategoryData[subcat].id);
    }
  }

  for (const i in subsubcategoryData) {
    for (const j in deletingids) {
      if (deletingids[j] == subsubcategoryData[i].id) {
        subsubcategoryData.splice(i, 1);
      }
    }
  }
  // console.log(subsubcategoryData, "subsubcategoryData");

  for (const t in allSectorIds) {
    if (allSectorIds[t] == element) {
      allSectorIds.splice(t, 1);
    }
  }

  // let filteredCat = categoryData.filter((f) => f.pid !== element);
  // store.dispatch("Sector/setCategoryAction", filteredCat); //updating in vuex
  // console.log(filteredCat, "filteredCat");

  let filteredCatselected = CatSelectedData?.filter((f) => f.pid !== element);
  store.dispatch("Sector/setcategorySelectedAct", filteredCatselected); //updating in vuex
  // console.log(filteredCatselected, "filteredCatselected");
  // console.log(categoryData, "categoryData");
  // console.log(store.getters["Sector/getcategorySector"]);

  //removing data from sub category dropdown
  let filteredSubCat = subCatData?.filter((f) => f.pid !== element);
  store.dispatch("Sector/setSubCategoryAction", filteredSubCat); //updating in vuex

  //removing data from sub sub category dropdown
  let filteredSubSubCat = subsubCatData?.filter((f) => f.pid !== element);
  store.dispatch("Sector/setSubSubCategoryAction", filteredSubSubCat); //updating in vuex

  //removing data from sub sub category selected data
  let filteredSubsubCat = subsubCatSelectedData.filter(
    (f) => f.pid !== element
  );
  // console.log(filteredSubsubCat, "filteredSubsubCat");
  store.dispatch("Sector/setsubsubcategorySelectedAct", filteredSubsubCat);
  // console.log(filteredSubsubCat, "filteredSubsubCat");

  //removing data from sub category selected data
  let filteredSubCatselected = subCatSelectedData.filter(
    (f) => f.pid !== element
  );
  // console.log(filteredSubCatselected, "filteredSubCatselected");

  store.dispatch("Sector/setsubcategorySelectedAct", filteredSubCatselected);

  let commPay = {
    id: element,
    sleBox: "sector",
    status: "dis",
  };
  store.dispatch("Sector/setCommunicationTypeData", commPay);

  disResponseMFlagInsurance.value = false;
  disResponseMFlagRest.value = false;
  disSelectResponseMechHandler();
}

// async function f() {
//   return [];
// }

function switchMediaFunctionCases(element) {
  // console.log(element, "ele");
  // let directMail = store.getters["Media/getDeliveryDirectMailFlagGetters"];
  // let dashboardExist = selectedData.value.includes(13);
  // let dashboardFlag = store.getters["Media/getDeliveryDirectMailFlagGetters"];
  let dashbBoardFlag = store.getters["Media/getDashboardBoxFlagGetters"];
  let dropdown = store.getters["Media/getselectedDataGetters"];
  let rawMedia = store.getters["Rawdata/getDropdownDataAPI"].mediachannel;
  let tempMediaIds = [];
  //the below will store all mChannelID in one array so that i can find
  //1) create array of all mChannelID ids tempSecIds
  for (let sec of rawMedia) {
    tempMediaIds.push(sec.mChannelID);
  }
  if (Object.keys(dropdown).length > 0) {
    //2) find selected mChannelID in the name of element in the created array tempMediaIds
    let uniqueMediaId = new Set([]);
    for (let med of dropdown["mChannelID"]) {
      uniqueMediaId.add(med.mChannelID);
    }
    // console.log(uniqueMediaId, "uniqueMediaId");
    for (let mid of rawMedia) {
      if (element === mid.mChannelID) {
        if (!uniqueMediaId.has(element)) {
          dropdown["mChannelID"].push(mid);
        }
      }
    }
  }

  // let dashboardDirectMailFlag =
  //   store.getters["Media/getDashboardDirectMailOptionBoxFlagGetters"];
  // console.log(isdashboardExist.value);
  switch (element) {
    case 2:
      store.dispatch("Media/setPrintPublicationTypeBoxFlag", true);
      // console.log("print", emitFlag.value);
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      break;
    case 1:
      // emitFlag.value = store.getters["Media/getDeliveryDirectMailFlagGetters"];
      // emitFlag.value = !emitFlag.value;
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      // console.log("emit", emitFlag.value);
      store.dispatch("Media/setDeliveryDirectMailFlag", true);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      // console.log("stat", selectedData.value.includes(13));
      if (dashbBoardFlag) {
        store.dispatch("Media/setDashboardDirectMailBoxFlagAction", true);
      }
      break;
    case 3:
      // emitFlag.value =
      //   store.getters["Media/getEmailElectronicTypeBoxFlagGetters"];
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      // emitFlag.value = !emitFlag.value;
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setEmailElectronicTypeBoxFlag", true);
      break;
    case 6:
      // emitFlag.value = !emitFlag.value;
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setSocialNetworkNameBoxFlag", true);
      break;
    case 13:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      store.dispatch("Media/setDashboardBoxFlagAction", true);
      // if (directMail) {
      //   store.dispatch("Media/setDashboardDirectMailBoxFlagAction", true);
      // }
      break;
    case 5:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      break;
    case 10:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      break;
    case 9:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      break;
    case 14:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
      store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
      break;
  }
}

function responseMechHandler() {
  // console.log("id", id);
  let responseMech =
    store.getters["Rawdata/getDropdownDataAPI"].response_machanism;
  // const allSectorIds = store.getters["Sector/getsectorIdComm"];
  // console.log(responseMech, "responseMech");

  let arr1 = [4, 5, 530];
  let arr2 = [372, 87, 90, 6, 315, 513, 522, 266, 525, 9, 219];
  let finalresponseMech = [];
  // console.log(allSectorIds, "allSectorIds");
  for (let i = 0; i <= arr1.length; i++) {
    sectorIdsSelected.value.forEach((a) => {
      if (arr1[i] === a) responseMFlagInsurance.value = true;
    });
  }

  for (let j = 0; j <= arr2.length; j++) {
    sectorIdsSelected.value.forEach((b) => {
      if (arr2[j] === b) responseMFlagRest.value = true;
    });
  }
  // console.log(responseMFlagInsurance, "insInvHrFlag");
  // console.log(responseMFlagRest, "restFlag");

  if (responseMFlagInsurance.value && responseMFlagRest.value) {
    store.dispatch("Sector/setresponseMechanismAPIAction", responseMech);
  } else if (responseMFlagInsurance.value) {
    finalresponseMech = responseMech.filter(
      (f) => Number(f.responseMechID) !== 2
    );

    store.dispatch("Sector/setresponseMechanismAPIAction", finalresponseMech);
  } else if (responseMFlagRest.value) {
    finalresponseMech = responseMech.filter(
      (f) => Number(f.responseMechID) !== 1
    );
    store.dispatch("Sector/setresponseMechanismAPIAction", finalresponseMech);
  }
}

function disSelectResponseMechHandler() {
  // console.log("id", id);
  let responseMech =
    store.getters["Rawdata/getDropdownDataAPI"].response_machanism;
  const allSectorIds = store.getters["Sector/getsectorIdComm"];

  let arr1 = [4, 5, 530];
  let arr2 = [372, 87, 90, 6, 315, 513, 522, 266, 525, 9, 219];
  let finalresponseMech = [];
  // console.log(allSectorIds, "allSectorIds");
  if (allSectorIds.length == 0) {
    store.dispatch("Sector/setresponseMechanismAPIAction", ["Any"]);
  }
  for (let i = 0; i <= arr1.length; i++) {
    allSectorIds.forEach((a) => {
      if (arr1[i] === a) disResponseMFlagInsurance.value = true;
    });
  }

  for (let j = 0; j <= arr2.length; j++) {
    allSectorIds.forEach((b) => {
      if (arr2[j] === b) disResponseMFlagRest.value = true;
    });
  }
  // console.log(disResponseMFlagInsurance, "insInvHrFlag");
  // console.log(disResponseMFlagRest, "restFlag");

  if (disResponseMFlagInsurance.value && disResponseMFlagRest.value) {
    store.dispatch("Sector/setresponseMechanismAPIAction", responseMech);
  } else if (disResponseMFlagInsurance.value) {
    finalresponseMech = responseMech.filter(
      (f) => Number(f.responseMechID) !== 2
    );

    store.dispatch("Sector/setresponseMechanismAPIAction", finalresponseMech);
  } else if (disResponseMFlagRest.value) {
    finalresponseMech = responseMech.filter(
      (f) => Number(f.responseMechID) !== 1
    );
    store.dispatch("Sector/setresponseMechanismAPIAction", finalresponseMech);
  }
}

async function sectorsFnHandler(id, actionName) {
  store.dispatch(
    "Sector/setOrignalCommuncationCopied",
    store.getters["Rawdata/getDropdownDataAPI"].communication_type
  );
  // console.log(id, actionName, "XXXX");
  let cat = store.getters["Sector/getAllCategoryLocalGetters"];
  let showcatstore = store.getters["Sector/getcategorySector"];
  // let storeData = store.getters["Sector/getcategorySector"];
  // const allSectorIds = store.getters["Sector/getsectorIdComm"];
  let showcat = [];
  let uniqueValues = new Set();
  for (let i = 0; i < Object.entries(cat).length; i++) {
    if (cat[i].pid === id) {
      showcat.push(cat[i]);
      uniqueValues.add(cat[i]);
    }
  }
  // showcatstore.forEach((t) => {
  //   showcat.push(t);
  // });
  // Loop through showcatstore
  showcatstore.forEach((t) => {
    if (!uniqueValues.has(t)) {
      showcat.push(t); // Push unique values from showcatstore
      uniqueValues.add(t); // Add the unique value to the set
    }
  });
  // console.log(showcat, "showcat");
  // console.log(showcatstore, "showcatstore");

  let commPay = {
    id: id,
    sleBox: "sector",
    status: "select",
  };
  store.dispatch("Sector/setCommunicationTypeData", commPay);
  store.dispatch(actionName, showcat);

  // console.log(storeData, "store");
  // let findStatus1 = allSectorIds.includes(id);
  // if (!findStatus1) {
  //   store.dispatch("Sector/setSectorIdsComm", id);
  // }
  responseMFlagInsurance.value = false;
  responseMFlagRest.value = false;
  responseMechHandler();
}
async function switchSectorFunctionCases(element) {
  // console.log("swtich hit", element);
  // console.log(disSelect.value, "dis");
  // let rawSector = store.getters["Rawdata/getsectorAPIPayloadGetters"]; //original sector data
  // one by one sector id will be found from original and push it inside in the store variable which comes from search api
  sectorIdsSelected.value.push(element);
  let rawSectors = store.getters["Rawdata/getDropdownDataAPI"].sectors;
  let dropdown = store.getters["Media/getselectedDataGetters"];
  if (Object.keys(dropdown).length > 0) {
    // let dropdown = store.getters["Media/getselectedDataGetters"];
    // console.log(dropdown, "drop", sectors);
    let uniqueSectorId = new Set([]);
    for (let med of dropdown["sectorID"]) {
      uniqueSectorId.add(med.sectorID);
    }
    // console.log(uniqueSectorId, "uniqueSectorId");
    for (let mid of rawSectors) {
      if (element === mid.sectorID) {
        if (!uniqueSectorId.has(element)) {
          dropdown["sectorID"].push(mid);
        }
      }
    }
  }

  // console.log(tempSecIds, "tempSecIds");
  //3) if found then find from raw sector and push it into dropdown
  // console.log(dropdown, "drop");

  let responseMech = JSON.parse(
    JSON.stringify(store.getters["Sector/getresponseMechanismAPIGett"])
  );
  let energyFlag = store.getters["Sector/getenergyBoxesFlag"];
  // let productnameboxFlag = store.getters["Sector/getCreditComboBoxesGetters"];
  // console.log("travelRetailCombo", travelRetailCombo);
  // let mortageFlag = store.getters["Sector/getMortageSelectedGett"];
  // let sectIdSelected = store.getters["Sector/getsectorIdComm"];

  // console.log("mortageFlag", mortageFlag);
  // productName.value = store.getters["Sector/"]
  // console.log("switch sector element", element);
  switch (element) {
    case 372:
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(372, "Sector/setCategoryAction");
        // store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
        store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
        // store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      }
      // emit("setCategory", finaldata);
      break;
    case 87:
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(87, "Sector/setCategoryAction");
        store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
        // store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      }
      break;
    case 90:
      productName.value = !productName.value;
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(90, "Sector/setCategoryAction");
      }
      // if (productnameboxFlag && !enableCreditCard.value) {
      //   store.dispatch("Sector/setCreditComboBoxesAction", false);
      //   store.dispatch("Sector/setBankCreditAction", false);
      // } else if (!enableCreditCard.value) {
      //   store.dispatch("Sector/setCreditComboBoxesAction", true);
      //   store.dispatch("Sector/setBankCreditAction", true);
      // }

      await store.dispatch("Sector/setProductNameAction", productName.value);
      break;
    case 315:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        if (energyFlag) {
          store.dispatch("Sector/setEnergyBoxesFlag", false);
        } else {
          dropApiCall(1);
          dropApiCall(3);
          dropApiCall(6);
          store.dispatch("Sector/setEnergyBoxesFlag", true);
        }
        // console.log(energyFlag, "energyFlag");
        await sectorsFnHandler(315, "Sector/setCategoryAction");
      }
      break;
    case 530:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(530, "Sector/setCategoryAction");
      }
      break;
    case 4:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      // eslint-disable-next-line no-case-declarations
      let insuranceBox = store.getters["Sector/getInsuranceBoxFlagGetters"];
      if (insuranceBox) {
        store.dispatch("Sector/setInsuranceBoxFlagAction", false);
      } else {
        store.dispatch("Sector/setInsuranceBoxFlagAction", true);
      }
      // console.log("insuranceBox", insuranceBox);
      // console.log(disSelect.value, "dis");
      if (!disSelect.value) {
        await sectorsFnHandler(4, "Sector/setCategoryAction");
      }
      break;
    case 5:
      // eslint-disable-next-line no-case-declarations
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      // eslint-disable-next-line no-case-declarations
      let investmentBox = store.getters["Sector/getInvestmentBoxFlagGetters"];
      if (investmentBox) {
        store.dispatch("Sector/setInvestmentBoxFlagAction", false);
      } else {
        store.dispatch("Sector/setInvestmentBoxFlagAction", true);
      }
      if (!disSelect.value) {
        await sectorsFnHandler(5, "Sector/setCategoryAction");
      }
      break;
    case 6:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      // console.log(mortageFlag, "1mortageFlags");
      // console.log(store.getters["Sector/getMortageSelectedGett"], "1get");
      if (disSelect.value) {
        store.dispatch("Sector/setMortageSelectedAction", false);
        store.dispatch("Sector/setLoanAmount", []);
        // await sectorsFnHandler(6, "Sector/setCategoryAction");
      } else {
        await sectorsFnHandler(6, "Sector/setCategoryAction");
      }
      //   store.dispatch("Sector/setMortageSelectedAction", true);
      // }
      // console.log(disSelect.value, "dis");
      // console.log(mortageFlag, "mortageFlags");
      // console.log(store.getters["Sector/getMortageSelectedGett"], "get");
      break;
    case 513:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(513, "Sector/setCategoryAction");
      }
      break;
    case 522:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(522, "Sector/setCategoryAction");
      }
      break;
    case 266:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(266, "Sector/setCategoryAction");
      }
      for (let [key, index] in responseMech) {
        if (responseMech[key].responseMechID === 1) {
          responseMech.splice(index, 1);
        }
      }
      store.dispatch("Sector/setresponseMechanismAction", responseMech);
      // console.log(sectorAPIdata, 999);
      // store.dispatch("Sector/setCategoryAction",
      break;
    case 525:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(525, "Sector/setCategoryAction");
      }
      break;
    case 9:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(9, "Sector/setCategoryAction");
      }

      break;
    case 219:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(219, "Sector/setCategoryAction");
      }
      break;
    case 559:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(559, "Sector/setCategoryAction");
      }
      break;
    case 560:
      store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
      store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
      if (!disSelect.value) {
        await sectorsFnHandler(560, "Sector/setCategoryAction");
      }
      break;
    default:
      emitFlag.value = false;
  }
  // console.log(store.getters["Rawdata/getsectorAPIPayloadGetters"], 99);
}
function sectorHandler() {
  // console.log(selectedData.value, 90);
  // let autoBankCreditCombo = [90].some((i) => selectedData.value.includes(i));
  let autoCreditCombo = !selectedData.value.includes(90);
  // let bankingCardAction = !selectedData.value.includes(87);
  let mortageLoan = !selectedData.value.includes(6);
  // let insurance = !selectedData.value.includes(4);
  // enableCreditCard.value = true;
  // console.log(autoBankCreditCombo, "autoBankCreditCombo");
  let travelRetailCombo = [266, 219, 559, 560].some((i) =>
    selectedData.value.includes(i)
  );
  let autoBankCreditCombo = [87, 90].some((i) =>
    selectedData.value.includes(i)
  );
  // console.log(autoBankCreditCombo, 90);

  if (travelRetailCombo) {
    store.dispatch("Sector/setTravelRetailBoxFlagAction", travelRetailCombo);
  } else {
    store.dispatch("Sector/setTravelRetailBoxFlagAction", travelRetailCombo);
  }
  // c
  if (autoBankCreditCombo) {
    store.dispatch("Sector/setBankingCardAction", autoBankCreditCombo);
  } else {
    store.dispatch("Sector/setBankingCardAction", autoBankCreditCombo);
  }
  if (!mortageLoan) {
    store.dispatch("Sector/setMortageSelectedAction", true);
  } else {
    store.dispatch("Sector/setMortageSelectedAction", false);
  }
  if (!autoCreditCombo) {
    store.dispatch("Sector/setCreditComboBoxesAction", true);
    store.dispatch("Sector/setBankCreditAction", true);
  } else {
    store.dispatch("Sector/setCreditComboBoxesAction", false);
    store.dispatch("Sector/setBankCreditAction", false);
  }
  switchSectorFunctionCases(selectedID.value);
}

function audienceHandler() {
  // console.log(selectedID.value);
  let status1 = !selectedData.value.includes(1);
  let status2 = !selectedData.value.includes(2);
  store.dispatch(
    "Sector/setOrignalCommuncationCopied",
    store.getters["Rawdata/getDropdownDataAPI"].communication_type
  );
  enableAudienceAll.value = true;
  if (!status1 || !status2) {
    store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
  } else {
    store.dispatch("Audience/setConsumerEmpBoxesFlagAction", false);
  }
  switchAudienceFunctionCases(selectedID.value);
}

function audienceDisSelectionHandler(el) {
  let status1 = !selectedData.value.includes(1);
  let status2 = !selectedData.value.includes(2);
  enableAudienceAll.value = true;
  if (!status1 || !status2) {
    store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
  } else {
    store.dispatch("Audience/setConsumerEmpBoxesFlagAction", false);
  }
  switchAudienceFunctionCases(el);
}
async function switchAudienceFunctionCases(element) {
  let consumerEmpBoxFlag =
    store.getters["Audience/getConsumerEmpBoxesFlagGetters"];
  let personalizedBoxFlag =
    store.getters["Audience/getpersonalizedFlagGetters"];
  let insuranceBoxFlag = store.getters["Audience/getInsuranceBoxFlagGetters"];
  if (selectedData.value.length > 0) {
    if (!personalizedBoxFlag) {
      store.dispatch(
        "Audience/setpersonalizedFlagAction",
        !personalizedBoxFlag
      );
    }
  } else {
    store.dispatch("Audience/setpersonalizedFlagAction", false);
  }
  if (!disSelect.value) {
    let commPay = {
      id: element,
      sleBox: "audience",
      status: "select",
    };
    store.dispatch("Sector/setCommunicationTypeData", commPay);
  } else {
    let commPay = {
      id: element,
      sleBox: "audience",
      status: "dis",
    };
    store.dispatch("Sector/setCommunicationTypeData", commPay);
  }

  let rawaudience = store.getters["Rawdata/getDropdownDataAPI"].audience;
  let dropdown = store.getters["Media/getselectedDataGetters"];
  if (Object.keys(dropdown).length > 0) {
    // let dropdown = store.getters["Media/getselectedDataGetters"];
    // console.log(dropdown, "drop", sectors);
    let uniqueSectorId = new Set([]);
    for (let med of dropdown["mPanelID"]) {
      uniqueSectorId.add(med.mPanelID);
    }
    // console.log(uniqueSectorId, "uniqueSectorId");
    for (let mid of rawaudience) {
      if (element === mid.mPanelID) {
        if (!uniqueSectorId.has(element)) {
          dropdown["mPanelID"].push(mid);
        }
      }
    }
  }

  switch (element) {
    case 1:
      store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      // store.dispatch("Rawdata/setWrenchIconAction", element);
      if (!consumerEmpBoxFlag & !enableAudienceAll.value) {
        store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
        // console.log(consumerEmpBoxFlag, "con");
      } else {
        // console.log(selectedData.value);
        // console.log(!selectedData.value.includes(1), 23);
        let status1 = !selectedData.value.includes(1);
        let status2 = !selectedData.value.includes(2);
        if (status1 && status2 && !enableAudienceAll.value) {
          store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
        }
        // console.log(consumerEmpBoxFlag, "con");
      }
      break;
    case 9:
      store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      break;
    case 2:
      store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      if (!consumerEmpBoxFlag && !enableAudienceAll.value) {
        store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
      } else {
        // console.log(selectedData.value);
        // console.log(!selectedData.value.includes(1, 2), 23);
        let status1 = !selectedData.value.includes(1);
        let status2 = !selectedData.value.includes(2);
        if (status1 && status2 && !enableAudienceAll.value) {
          store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
        }
      }
      break;
    case 4:
      store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      // store.dispatch("Rawdata/setWrenchIconAction", element);
      if (insuranceBoxFlag) {
        store.dispatch("Audience/setInsuranceBoxFlagAction", !insuranceBoxFlag);
      } else {
        store.dispatch("Audience/setInsuranceBoxFlagAction", !insuranceBoxFlag);
      }
      break;
    case 6:
      store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      break;
    case 5:
      store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      break;
    default:
      emitFlag.value = false;
  }
  // console.log(consumerEmpBoxFlag, "consumerEmpBoxFlag");
  if (consumerEmpBoxFlag) {
    dropApiCall(2);
    dropApiCall(4);
    dropApiCall(5);
  }
}

function offerOriginFn(id, dis) {
  // console.log(id, dis);
  let obj = store.getters["Rawdata/getofferOriginChanged"];
  if (dis === "add") {
    for (let i = 0; i < obj.length; i++) {
      let sectors = obj[i].oo_sectorID;
      ``;
      if (sectors.includes(id)) {
        // Check for duplicates before pushing
        let found = offerOrigin.value.some(
          (item) => item.oo_id === obj[i].oo_id
        );
        if (!found) {
          offerOrigin.value.push(obj[i]);
        }
      }
    }
  } else if (dis === "delete") {
    // If 'delete' parameter is passed, remove the object from the offerOrigin.value array
    for (let i = 0; i < offerOrigin.value.length; i++) {
      let sectors = offerOrigin.value[i].oo_sectorID;
      if (sectors.includes(id)) {
        // Use splice to remove the item from array by index
        offerOrigin.value.splice(i, 1);
        i--; // Decrement index after removal to avoid skipping elements
      }
    }
  } else if (dis === "all") {
    offerOrigin.value = [];
  }
  // console.log(offerOrigin.value, offerOrigin.value);
  store.dispatch("Sector/setOfferOrigin", offerOrigin.value);
}
// function offerOrigin(id, dis) {
//   console.log(dis, "diaas");
//   let offerOriginAll = store.getters["Rawdata/getDropdownDataAPI"].offer_origin;
//   let offerOriginSelected = store.getters["Sector/getOfferOrigin"];
//   let offerOriginDataNames = [
//     { oo_id: 0, oo_mChannelID: "", oo_name: "Select One", oo_sectorID: "" },
//   ];
//   let offerOriginPayload = store.getters["Sector/getSiDropDownPayload"];
//   // console.log(copiedofferOriginSelected, "off");
//   if (offerOriginSelected !== undefined) {
//     if (dis) {
//       let uncheckOfferOrigin = undefined;
//       for (let i = 0; i < offerOriginSelected.length; i++) {
//         uncheckOfferOrigin = offerOriginSelected.filter(
//           (f) => !f.oo_sectorID.includes(dis.toString())
//         );
//         // console.log(uncheckOfferOrigin, "uncheckOfferOrigin");
//         if (uncheckOfferOrigin.length === 1) {
//           uncheckOfferOrigin = [];
//           delete offerOriginPayload.offer_origin_id;
//         }
//       }
//       store.dispatch("Sector/setOfferOrigin", uncheckOfferOrigin);
//     } else {
//       const idsArr = String(id).split(" ").map(String);
//       // console.log(typeof idsArr, "idsArr");
//       // console.log(idsArr, "idsArr");
//       // let FilteredOriginData = store.getters["Sector/getOfferOrigin"];
//       for (let i = 0; i < offerOriginAll.length; i++) {
//         let secidArray = offerOriginAll[i].oo_sectorID
//           .split(",")
//           .map((id) => id.trim());
//         // console.log(secidArray, "secidArray");
//         let status;

//         // console.log(e[j], "e[j]");
//         for (let j = 0; j < idsArr.length; j++) {
//           status = secidArray.includes(idsArr.toString());
//           // console.log(status, "status");
//           // console.log(offerOriginAll[i], "offerOriginAll[i]");
//         }
//         if (status) {
//           // console.log(status, "status1");
//           if (filtOr.value.length === 0) {
//             filtOr.value.push({
//               oo_id: 0,
//               oo_mChannelID: "",
//               oo_name: "Select One",
//               oo_sectorID: "",
//             });
//             filtOr.value.push(offerOriginAll[i]);
//           } else {
//             // console.log(status, "status2");
//             // console.log(offerOriginAll[i].oo_id, "offerOriginAll[i].id");
//             let exists = filtOr.value.some(
//               (item) => item.oo_id === offerOriginAll[i].oo_id
//             );
//             // console.log(exists, "exists1");
//             if (!exists) {
//               // console.log(exists, "exists1");
//               // console.log(offerOriginAll[i].oo_id, "offe 1");
//               filtOr.value.push(offerOriginAll[i]);
//             }
//           }
//         }
//       }

//       // console.log(filtOr.value, "filtOr");
//       if (filtOr.value) {
//         store.dispatch("Sector/setOfferOrigin", filtOr.value);
//       } else {
//         store.dispatch("Sector/setOfferOrigin", offerOriginDataNames);
//       }

//       // console.log(offerOriginSelected, "off");
//     }
//   }
//   // console.log(offerOriginAll, "offerOriginAll");
//   // let offerOriginDataNames = [];
//   // if (id.length > 0) {
//   //   for (let i = 0; i < offerOrigin.length; i++) {
//   //     let secidArray = offerOrigin[i].oo_sectorID
//   //       .split(",")
//   //       .map((id) => id.trim());
//   //     // console.log(secidArray, "secidArray");
//   //     let status;
//   //     for (let j = 0; j < id.length; j++) {
//   //       // console.log(e[j], "e[j]");
//   //       status = secidArray.includes(id[j].toString());
//   //       // console.log(status, "status");
//   //       if (status && offerAddedData.length == 0) {
//   //         console.log(status, "status1");
//   //         offerAddedData.push(offerOrigin[i]);
//   //       } else if (status) {
//   //         console.log(status, "status2");
//   //         console.log(offerOrigin[i].oo_id, "offerOrigin[i].id");
//   //         let exists = offerAddedData.some(
//   //           (item) => item.oo_id === offerOrigin[i].oo_id
//   //         );
//   //         if (!exists) {
//   //           console.log(exists, "exists1");
//   //           console.log(offerOrigin[i].oo_id, "offe 1");
//   //           offerAddedData.push(offerOrigin[i]);
//   //         } else {
//   //           console.log(offerOrigin[i].oo_id, "offe 2");
//   //           console.log(exists, "exists2");
//   //           offerAddedData.splice(i, 1);
//   //         }
//   //       }
//   //     }
//   // console.log(status, "status");
//   // }
//   // }
//   // store.dispatch("Sector/setOfferOrigin", offerOriginDataNames);
// }

function viewValueGetter(obj, dynamicID) {
  let arr = [];
  for (let o in obj) {
    arr.push(obj[o][dynamicID]);
  }
  view.value = arr;
}
function clickHandler(e) {
  // let len = e.length;
  store.dispatch("Media/setlastSearchTriggerredAction", false);
  let dropdown = store.getters["Media/getselectedDataGetters"];
  let selectedUpdateArray = [];
  // console.log("EEEe.", e, 122, finalColumn.value, props.propsData);
  // console.log("props", props.boxName);
  // console.log(JSON.parse(JSON.stringify(view.value)), 90); //solution is to copy the before
  // console.log(e, 89);
  let checkboxSelected = JSON.parse(JSON.stringify(view.value));
  const searchCry = {
    val: e,
    column: props.boxName,
    entirs: props.propsData,
  };
  store.dispatch("Rawdata/setSearchCritertia", searchCry);
  // console.log(searchCry, "searchCry");
  // console.log(checkboxSelected.length, "len");
  // console.log(view.value, "view");
  disSelect.value = null;
  if (e.length >= view.value.length) {
    if (e.length != 0 && e !== undefined) {
      for (let i of e) {
        // console.log("first i", i);
        let found = !JSON.parse(JSON.stringify(checkboxSelected)).includes(i);
        // console.log(found, "firstfound");
        if (found) {
          selectedID.value = i;
          // offerOrigin(i);
        } else {
          selectedID.value = i;
          // offerOrigin(i);
        }
      }
      view.value = e;
    }
  } else {
    if (view.value.length != 0 && view.value !== undefined) {
      for (let i of view.value) {
        // console.log("second i", i);
        let found = !JSON.parse(JSON.stringify(e)).includes(i);
        // console.log(found, "second found");
        if (found) {
          // console.log(i, "i");
          disSelect.value = i;
          // offerOrigin(null, i);
        }
      }
      view.value = e;
    }
    // offerOrigin(disSelect.value);
  }
  // else {
  //   console.log("else", e[0]); //its going in this loop always, this is the issue, coz of this its going in the loop and not getting new aluea
  //   selectedID.value = e[0];
  //   view.value = e;
  // }
  // if (selectAllFlag.value) {
  //   disSelect.value = selectedID.value;
  // }
  // let len = e.length;
  // selectedID.value = e[len - 1]; //problem herenow solved
  // console.log(disSelect.value, "disSelect");
  // console.log(selectedID.value, "sel");
  // disSelect.value = previousSelectedStructures.value.filter(
  //   (item) => !e.includes(item)
  // );
  // console.log("diselect", disSelect.value);
  previousSelectedStructures.value = e;

  if (disSelect.value) {
    if (props.boxName === "Media Channel") {
      // console.log(67, disSelect.value[0], "des");
      mediaDisSelectionHandler(disSelect.value);
    } else if (props.boxName === "Sectors") {
      checkCommType.value = true;
      offerOriginFn(disSelect.value, "delete");
      sectorsDisSelectionHandler(disSelect.value);
    } else if (props.boxName === "Audience") {
      audienceDisSelectionHandler(disSelect.value);
    } else if (props.boxName === "Electronic Type") {
      store.dispatch("Rawdata/setelectronicTypePayloadAction", e);
    } else if (props.boxName === "Publication Type") {
      store.dispatch("Rawdata/setPublicationTypePayloadAction", e);
    } else if (props.boxName === "Group Size") {
      store.dispatch("Rawdata/setgroupSizePayloadPayloadAction", e);
    } else if (props.boxName === "Issue Type") {
      store.dispatch("Rawdata/setissueTypePayloadAction", e);
    } else if (props.boxName === "Introductory Pricing") {
      store.dispatch("Rawdata/setintroductoryPricingPayloadAction", e);
    }
  } else {
    if (props.boxName === "Media Channel") {
      dropdown["mChannelID"].forEach((t) => {
        if (e.includes(t.mChannelID)) {
          selectedUpdateArray.push(t);
        }
      });
      dropdown["mChannelID"] = selectedUpdateArray;
      mediaHandler();
    } else if (props.boxName === "Sectors") {
      dropdown["sectorID"].forEach((t) => {
        if (e.includes(t.sectorID)) {
          selectedUpdateArray.push(t);
        }
      });
      dropdown["sectorID"] = selectedUpdateArray;
      offerOriginFn(selectedID.value, "add");
      sectorHandler();
    } else if (props.boxName === "Audience") {
      dropdown["mPanelID"].forEach((t) => {
        if (e.includes(t.mPanelID)) {
          selectedUpdateArray.push(t);
        }
      });
      dropdown["mPanelID"] = selectedUpdateArray;
      audienceHandler();
    } else if (props.boxName === "Search Date") {
      store.dispatch("Rawdata/setUserSearchDate", e);
    } else if (props.boxName === "Communication Type") {
      store.dispatch("Rawdata/setcommunicationTypeSelectionAction", e);
    } else if (props.boxName === "Delivery Method") {
      store.dispatch("Rawdata/setDeliveryMethodPayloadAction", e);
    } else if (props.boxName === "Group Size") {
      store.dispatch("Rawdata/setgroupSizePayloadPayloadAction", e);
    } else if (props.boxName === "Electronic Type") {
      store.dispatch("Rawdata/setelectronicTypePayloadAction", e);
    } else if (props.boxName === "Publication Type") {
      store.dispatch("Rawdata/setPublicationTypePayloadAction", e);
    } else if (props.boxName === "Issue Type") {
      store.dispatch("Rawdata/setissueTypePayloadAction", e);
    } else if (props.boxName === "Introductory Pricing") {
      store.dispatch("Rawdata/setintroductoryPricingPayloadAction", e);
    }
  }
  if (props.boxName === "Delivery Method") {
    store.dispatch("Sector/setDeliveryMethodId", e);
    if (e.includes(1) || e.includes(3) || e.includes(7)) {
      store.dispatch("Media/setDashboardDirectMailBoxFlagAction", true);
    } else {
      store.dispatch("Sector/setPostageId", []);
      store.dispatch("Sector/setDeliveryTypeId", []);
      store.dispatch("Sector/setPresortedId", []);
      store.dispatch("Sector/setPackageTypeId", []);
      store.dispatch("Media/setDashboardDirectMailBoxFlagAction", false);
    }
  }
  if (props.boxName === "Delivery Type") {
    store.dispatch("Sector/setDeliveryTypeId", e);
  }
  if (props.boxName === "Postage") {
    store.dispatch("Sector/setPostageId", e);
  }
  if (props.boxName === "Pre-Sorted") {
    store.dispatch("Sector/setPresortedId", e);
  }
  if (props.boxName === "Package Type") {
    store.dispatch("Sector/setPackageTypeId", e);
  }
  if (
    props.boxName === "EDC / LDC / TDSP" ||
    props.boxName === "Energy - Rate Type" ||
    props.boxName === "Offer Price (¢ per kWh)" ||
    props.boxName === "Energy - Term Length"
  ) {
    const pay = {
      values: e,
      boxname: props.boxName,
    };
    // console.log("WWWww", pay);
    store.dispatch("Sector/setEnergySetPayload", pay);
  }
  if (props.boxName === "Target Markets") {
    store.dispatch("Sector/setTargetIDs", e);
  }
  // console.log(props.boxName, "boxname");
  if (
    props.boxName === "Mailing Type" ||
    props.boxName === "DMA®" ||
    props.boxName === "Age" ||
    props.boxName === "Business Content" ||
    props.boxName === "VantageScore" ||
    props.boxName === "Riders" ||
    props.boxName === "Face Amount" ||
    props.boxName === "Income" ||
    props.boxName === "Income Producing Assets Segment Code *R*" ||
    props.boxName === "Value Score" ||
    props.boxName === "Application Type" ||
    props.boxName === "FicoScore" ||
    props.boxName === "CreditVision" ||
    props.boxName === "State/Province" ||
    props.boxName === "Term Length" ||
    props.boxName === "Communication Type"
  ) {
    const pay = {
      values: e,
      boxname: props.boxName,
    };
    if (e !== "Any") {
      store.dispatch("Sector/setSiDropDownPayload", pay);
    }

    // console.log("Boxname: ", props.boxName, "Values", e);
  }
  // if (props.boxName === "Sectors") {
  //   offerOrigin(e);
  // }
  if (
    props.boxName === "Ancillary Products" ||
    props.boxName === "Response Mechanism" ||
    props.boxName === "Card Network"
  ) {
    const pay = {
      values: e,
      boxname: props.boxName,
    };
    // console.log("WWWww", pay);
    store.dispatch("Sector/setDefaultDropdown", pay);
  }
}
</script>
<style>
.v-list-item--link {
  margin-top: -5px;
}
.v-list-item-title {
  font-size: 12px;
  font-family: sans-serif;
}
.v-list-item__title {
  font-size: 7px !important;
  color: red;
}
</style>
<!-- <style scoped>
* {
  color: #0a0a0a;
}
* {
  color: #0a0a0a !important;
}
</style> -->
